<template>
  <footer class="footer" :class="{ 'is-mobile': $isMobile }">
    <section class="footer-content">
      <img src="../../assets/logo.png" alt="" class="logo" />
      <div class="info">
        <div><img class="bottom-icon" v-if="$isMobile" src="../../assets/mobile/address.png" alt=""> 地址：北京市复兴门内大街 45 号</div>
        <div><img class="bottom-icon" v-if="$isMobile" src="../../assets/mobile/text-message.png" alt=""> 邮编：100801</div>
        <div><img class="bottom-icon" v-if="$isMobile" src="../../assets/mobile/e_mail.png" alt=""> E-mail：zhongshangqixie@163.com</div>
        <div><img class="bottom-icon" v-if="$isMobile" src="../../assets/mobile/phone.png" alt=""> 电话: 010-66095405、66095626</div>
      </div>

      <div class="line"></div>
      <div class="link">中国商业企业管理协会 版权所有 <a style="color: #fff;" href="https://beian.miit.gov.cn/" target="_blank">京ICP备07503556号-1</a> </div> 

      <div class="wechat">
        <img src="../../assets/wechat.png" alt="" class="wechat-img" />
        <div class="wechat-text">官方微信</div>
      </div>
    </section>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.footer {
  height: 276px;
  background: #469df4;
  width: 100%;
  min-width: 1200px;
  // flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;

  .footer-content {
    // padding-top: 46px;
    width: 1200px;
    position: relative;
  }

  .wechat {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    flex-direction: column;

    .wechat-img {
      width: 80px;
      height: 80px;
    }

    .wechat-text {
      margin-top: 9px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
  }

  .logo {
    margin-bottom: 49px;
  }

  .info {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    gap: 16px;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .line {
    width: 100%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.58);
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .link {
    cursor: pointer;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }


}

.footer.is-mobile {
  height: max-content;
  min-width: auto;
  padding: 1rem;
  align-items: flex-start;
  .logo {
    margin-bottom: 1rem;
    height: 2rem;
    width: 12rem;
  }

  .wechat,
  .line,
  .link {
    display: none;
  }

  .footer-content {
    width: 100%;
    padding-top: 10px;
    min-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .bottom-icon{
      height: 1rem;
      width: 1rem;
      margin-right: 0.6rem;
    }

    .info {
      width: 100%;
      padding-top: 1rem;
      border-top: 1px solid #fff;
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-bottom: 10px;
      div{
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>

